module.exports = {"id":"183569","name":"Eric Maxim Choupo-Moting","rating":"78","photo":"./data/images/photos/0/183569.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["MG","BU","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EricMaximChoupo-Moting0.json
// module id = 1274
// module chunks = 0